export const Rater = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 7H20" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M8 11H20" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M8 15H14" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M8 25H14" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M23 14V4C23 3.44772 22.5523 3 22 3H6C5.44772 3 5 3.44772 5 4V28C5 28.5523 5.44772 29 6 29H14" stroke="currentColor" stroke-width="2"/>
<circle cx="4" cy="4" r="3" transform="matrix(-1 0 0 1 28 16)" stroke="currentColor" stroke-width="2"/>
<path d="M19 30V28C19 26.8954 19.8954 26 21 26H27C28.1046 26 29 26.8954 29 28V30" stroke="currentColor" stroke-width="2"/>
</svg>`;
